// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"featuredEvents-module--wrapper--AZfDJ","cardsContainer":"featuredEvents-module--cardsContainer--iTmRr"};